export default "__VITE_ASSET__BAh8G_FA__"